module.exports = __webpack_public_path__ + "static/media/south-western_iberian_preview.86b9512f.png";